window.SMTX.stickyCtaModule = (function () {
  const PARENT_MODULE = '.sticky-cta-module';
  const BUTTON = '.sticky-cta-module__button';
  const FORM = '.sticky-cta-module__form';
  const FORM_BUTTON = '.sticky-cta-module__form__button[data-form-submit]';
  
  if ($(PARENT_MODULE).length === 0) {
    return false;
  }
  
  function trackPardot(formHandlerId, data) {
    if (!formHandlerId || !window.SMTX.PardotTracker) {
      return false;
    }
    
    var conv_url = window.document.referrer;
    if (conv_url === null || conv_url === undefined || conv_url === '') {
      conv_url = window.location.href;
    }

    var marketingLanguage = window.SMTX.stickyCtaModuleSettings.pardot_marketing_language;

    data = {
      Marketing_Language: marketingLanguage,
      conversion_URL: conv_url,
      ...data,
    };
    
    var qryStr = jQuery.param(data);
    var iframeSrc = 'https://info.semantix-group.com/' + formHandlerId + '?' + qryStr;

    $(PARENT_MODULE).append($('<iframe src="' + iframeSrc + '" width="1" height="1"></iframe>'));
  }
  
  function submitButton(e) {
    var formHandlerId = window.SMTX.stickyCtaModuleSettings.form_handler_id;
    var marketingLanguage = window.SMTX.stickyCtaModuleSettings.pardot_marketing_language;

    if (!formHandlerId || !marketingLanguage) {
      return false;
    }

    trackPardot(formHandlerId, {});
  }

  function submitForm(e, formId) {
    var formData = {};
    var hasError = false;
    var formDataId = '[data-form-id="' + formId + '"]';
    var $inputFields = $(FORM + formDataId + ' input[type="text"]', PARENT_MODULE);
    
    $inputFields.each(function () {
      var $field = $(this);
      var isRequired = typeof $field.attr('data-required') !== 'undefined';
      
      if (isRequired && $field.val().length === 0) {
        $field.addClass('error');
        hasError = true;
        return false;
      }
      
      formData[$field.attr('data-field-id')] = $field.val();
    });
    
    if (hasError) {
      return false;
    }
    
    var formHandlerId = window.SMTX.stickyCtaModuleSettings.form_handler_id;
    
    if (!formHandlerId) {
      return false;
    }
    
    trackPardot(formHandlerId, {
      ...formData,
    });
    
    var $button = $(FORM + formDataId + ' .sticky-cta-module__form__button-container .sticky-cta-module__form__button');
    var $successMessage = $(
      FORM + formDataId + ' .sticky-cta-module__form__button-container .sticky-cta-module__form__success-message'
    );
    
    setTimeout(function () {
      $button.addClass('hidden');
      $successMessage.addClass('show');
    }, 250);
    
    $inputFields.each(function () {
      const $field = $(this);

      $field.val('');
      $field.removeClass('error');
    });
    
    
    setTimeout(function () {
      $successMessage.removeClass('show');
      $button.removeClass('hidden');
    }, 5000);
  }
  
  $(BUTTON, PARENT_MODULE).on('click', function (e) {
    submitButton(e);
  });
  
  $(FORM_BUTTON, PARENT_MODULE).on('click', function (e) {
    const $form = $(this).closest(FORM);
    const formId = $form.attr('data-form-id');

    submitForm(e, formId);
  });
})();
